import { Entity } from '@backstage/catalog-model';

import { Stakeholder, MedidataComponent } from './types';

/**
 * This function reads an Entity (component) and creates a MedidataComponent
 * A MedidataComponent has all the fields of the Entity + a mdsol field
 * which allows easy access to the extra information we added to the factbooks
 * like aliases, stakeholders and others.
 */
export const toMedidataComponent = (entity: Entity): MedidataComponent => {
  const experience = entity.spec?.experience ?? '';
  const stakeholders = entity.metadata.stakeholders as Stakeholder[];

  const architects =
    stakeholders?.filter(stakeholder => stakeholder.role === 'architect') || [];
  const techOwners =
    stakeholders?.filter(
      stakeholder => stakeholder.role === 'technical owner',
    ) || [];
  const technicalOwners = architects.concat(techOwners);
  const productOwners =
    stakeholders?.filter(stakeholder => stakeholder.role === 'product owner') ||
    [];

  const aliases = entity.metadata.aliases as string[];

  const extensions = {
    experience,
    stakeholders,
    technicalOwners,
    productOwners,
    aliases,
  };

  const medidataComponent = {
    ...entity,
    mdsol: extensions,
  };

  return medidataComponent as MedidataComponent;
};
